import { CompanyDraftContent } from '@blockpulse3/graphql/hooks';

import { FinancialInformationsForm } from '../../Forms/FinancialInformationsForm';
import { useSPVForm } from '../../provider';

type Props = {
  onCancel: () => void;
  onSubmit: (data: CompanyDraftContent) => void;
};

/**
 * FinancialInformationsStep.
 * Step that renders the form for the financial informatinos of the SPV.
 *
 * @param {Props}
 * @returns {JSX.Element}
 */
export function FinancialInformationsStep({ onCancel, onSubmit }: Props): JSX.Element {
  const { companyDraftContent } = useSPVForm();

  const handleStepSubmit = (data: CompanyDraftContent): void => {
    onSubmit(data);
  };

  const handleStepCancel = (): void => {
    onCancel();
  };

  return (
    <FinancialInformationsForm
      defaultValues={companyDraftContent}
      onCancel={handleStepCancel}
      onSubmit={handleStepSubmit}
    />
  );
}

export type FinancialInformationsStepProps = Props;
